module.exports = __webpack_public_path__ + "img/62b13e2.jpeg";